<template>
  <div class="text-center">
    <v-dialog v-model="modalConfig" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          {{ t("configuracao") }}
          <v-icon class="icon" @click="showDevTools()">mdi-cogs</v-icon>
        </v-card-title>
        <v-card-text>
          <v-form v-model="valid">
            <v-text-field
              v-model="config.servidor"
              :label="t('enderecoXcontact')"
              required
              :rules="[(v) => !!v || t('fraseCampoObrigatorio')]"
            ></v-text-field>
            <v-text-field
              v-model="config.pabx"
              :label="t('enderecoPabx')"
              required
              :rules="[(v) => !!v || t('fraseCampoObrigatorio')]"
            ></v-text-field>
            <v-select
              v-model="config.idioma"
              :items="items"
              :label="t('idioma')"
              :rules="[(v) => !!v || t('fraseCampoObrigatorio')]"
              required
            ></v-select>
            <v-checkbox v-model="config.webrtc" :label="`Webrtc`"></v-checkbox>
            <v-combobox
              v-model="config.headers"
              :items="[]"
              :label="t('dadosDeIntegracao')"
              multiple
              chips
            >
              <template v-slot:selection="data">
                <v-chip
                  :key="JSON.stringify(data.item)"
                  v-bind="data.attrs"
                  :input-value="data.selected"
                  :disabled="data.disabled"
                  @click:close="data.parent.selectItem(data.item)"
                >
                  <v-avatar
                    class="accent white--text"
                    left
                    v-text="data.item.slice(0, 1).toUpperCase()"
                  ></v-avatar>
                  {{ data.item }}
                </v-chip>
              </template>
            </v-combobox>
            <v-checkbox
              v-model="config.notificacao"
              :label="t(`habilitarNotificacaoes`)"
            ></v-checkbox>
            <v-checkbox
              v-show="config.notificacao"
              v-model="config.somnotificacao"
              :label="t(`reproduzirAudioNasNotificaçõesDeMensagens`)"
            ></v-checkbox>
            <v-checkbox
              v-model="config.obrigaClassificarLigacao"
              :label="t(`obrigaClassificarLigacao`)"
            ></v-checkbox>
            <v-checkbox
              v-model="config.autoAtendimento"
              :label="t(`autoAtendimento`)"
            ></v-checkbox>

            <v-text-field
              v-model="config.urlIntegracao"
              :label="t('urlIntegracao')"
            ></v-text-field>
            <!-- <v-text-field
              v-model="config.nome"
              label="Seu Nome"
              required
              :rules="[v => !!v || 'É obrigatório']"
            ></v-text-field>
            <v-text-field
              v-model="config.ramal"
              label="Ramal"
              required
              :rules="[v => !!v || 'É obrigatório']"
            ></v-text-field>
            <v-text-field
              v-model="config.senha"
              type="password"
              label="Senha"
              required
              :rules="[v => !!v || 'É obrigatório']"
            ></v-text-field>-->
          </v-form>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="salvar" :disabled="!valid">{{
            t("salvar")
          }}</v-btn>
          <v-btn v-if="cancel" color="red" text @click="onCancel">{{
            t("cancelar")
          }}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
   
<script>
import { mapActions } from "vuex";
import { mapState } from "vuex";
import Api from "../plugins/Api";
export default {
  name: "conn-config",
  props: {
    open: { type: Boolean, default: true },
    cancel: { type: Boolean, default: false },
    inputDevices: { type: Array, default: null },
    outputDevices: { type: Array, default: null },
  },
  data() {
    return {
      valid: true,
      config: {},
      items: ["pt_BR", "es_cl", "eng_US"],
    };
  },
  computed: {
    ...mapState("xc", {
      modalConfig: (state) => state.modalConfig,
      conectado: (state) => state.conectado,
    }),
  },
  created() {
    this.loadData();
  },
  methods: {
    ...mapActions("xc", ["setModalConfig", "disconnect"]),
    ...mapActions("auth", ["setStatus"]),
    loadData() {
      if (localStorage.getItem("config")) {
        this.config = JSON.parse(localStorage.getItem("config"));
      }
    },
    onCancel() {
      this.loadData();
      //this.$emit("update:open", false);
      this.setModalConfig(false);
    },
    salvar() {
      localStorage.setItem("config", JSON.stringify(this.config));
      if (this.conectado) this.disconnect();

      Api.http.defaults.baseURL = `http://${this.config.servidor}`;
      this.setStatus(null);
      //this.$router.push(`/login`);
      //window.location.reload();
      this.setModalConfig(false);
    },
    showDevTools() {},
  },
};
</script>